import { EMAIL_EDIT } from './index';
import { Action } from '../action';
import { EmailEditForm } from '@shared/core';

export class EmailEditInitAction implements Action {
	readonly type = EMAIL_EDIT.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class EmailEditDestroyAction implements Action {
	readonly type = EMAIL_EDIT.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class EmailEditClickSubmitAction implements Action {
	readonly type = EMAIL_EDIT.CLICK_SUBMIT;
	constructor(
		public payload: EmailEditForm,
		public correlationId?: number
	) {}
}

export class EmailEditUpdateFormAction implements Action {
	readonly type = EMAIL_EDIT.UPDATE_FORM;
	constructor(
		public payload: EmailEditForm,
		public correlationId?: number
	) {}
}
